{
  "nl": {
    "option-is-required": "Kies een optie",
    "pick-a-transport": "Kies een vervoer",
    "pick-a-gender": "Kies een geslacht",
    "pick-a-language": "Kies een taal",
    "how-to-reheat-meal": "Kies hoe je je maaltijd opgewarmd wilt hebben"
  },
  "en": {
    "option-is-required": "Pick an option",
    "pick-a-transport": "Pick a transport",
    "pick-a-gender": "Pick a gender",
    "pick-a-language": "Pick a language",
    "how-to-reheat-meal": "Choose how you want your meal reheated"
  }
}
